/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: '#304BC8',
      light: '#6A7DDB',
    },
    secondary: {
      main: '#598519',
      light: '#D4D4D4',
    },
  },
  typography: {
    h2: {
      fontSize: '4rem',
      fontWeight: 600,
    },
    h4: {
        fontSize: '2rem',
        fontWeight: 500,
      },
  },
});

export default theme;
